module.exports = __webpack_public_path__ + "staticVue/img/home-icon.3bbcca8d.png";